export const ROUTER_LOGIN_PATH = '/login';
export const ROUTER_DEFAULT_PATH = '/';
